import React from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const DivisionsPage = () => {
  const divisions = [
    {
      id: 'palm-oil',
      label: 'Division 01',
      icon: 'ri-plant-line',
      title: 'Palm Oil',
      company: 'Drixem Mega Sdn Bhd',
      description:
        'Drixem Mega Sdn Bhd is Malaysia\'s leading palm oil specialist with over 10 years of proven expertise. We deliver comprehensive palm oil solutions including Palm Oil Mill & Refinery Setup consultation, premium palm oil exporting (CP6, CP8, CP10 grades with flexible packaging), and OEM Contract Manufacturing with custom branding. Government-certified quality with JAKIM Halal, MPOB licences, and Malaysian MOH compliance, serving clients across all five continents.',
      image:
        'https://public.readdy.ai/ai/img_res/a6b93acdd50fce5ed4778964f73676f9.jpg',
      features: [
        {
          icon: 'ri-building-line',
          title: 'Mill & Refinery Setup',
          desc: 'Complete consultation and setup services for palm oil mills and refineries with cutting-edge technology.',
        },
        {
          icon: 'ri-ship-line',
          title: 'Premium Exporting',
          desc: 'CP6, CP8, CP10 grade palm oil export to five continents with flexible packaging options.',
        },
        {
          icon: 'ri-settings-3-line',
          title: 'OEM Manufacturing',
          desc: 'Custom branded palm oil products manufactured with full compliance and quality assurance.',
        },
        {
          icon: 'ri-shield-check-line',
          title: 'Government Certified',
          desc: 'JAKIM Halal, MPOB licensed, and Malaysian MOH certified for global markets.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Palm Oil',
    },
    {
      id: 'manufacturing',
      label: 'Division 02',
      icon: 'ri-settings-3-line',
      title: 'Manufacturing',
      company: 'Drixem Nexus Manufacturing Sdn Bhd',
      description:
        'Drixem Nexus Manufacturing Sdn Bhd operates a state-of-the-art palm cooking oil packaging plant with full AP (Approved Permit) Export capabilities. Our facility handles end-to-end production from refining to bottling, labelling, and packaging under strict quality control. With AP Export permit, we enable seamless international distribution of palm cooking oil products under OEM and custom branding.',
      image:
        'https://readdy.ai/api/search-image?query=Modern%20automated%20cooking%20oil%20bottling%20and%20packaging%20production%20line%20inside%20clean%20factory%20with%20conveyor%20belts%20filling%20machines%20capping%20stations%20and%20labelling%20equipment%20stainless%20steel%20machinery%20golden%20cooking%20oil%20being%20filled%20into%20bottles%20bright%20industrial%20lighting%20professional%20manufacturing%20photography&width=800&height=600&seq=div-mfg-v3&orientation=landscape',
      features: [
        {
          icon: 'ri-settings-3-line',
          title: 'Packaging Plant',
          desc: 'Full palm cooking oil packaging plant with bottling, labelling, and quality control.',
        },
        {
          icon: 'ri-file-list-line',
          title: 'AP Export Permit',
          desc: 'Approved Permit (AP) for international export of palm cooking oil products.',
        },
        {
          icon: 'ri-building-line',
          title: 'OEM Branding',
          desc: 'Custom branded cooking oil products manufactured with full compliance.',
        },
        {
          icon: 'ri-shield-check-line',
          title: 'Quality Assurance',
          desc: 'Rigorous quality control at every stage from refining to final packaging.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Manufacturing',
    },
    {
      id: 'property-development',
      label: 'Division 03',
      icon: 'ri-building-line',
      title: 'Property Development',
      company: 'Heuliez (M) Sdn Bhd (Est. 1996)',
      description:
        'Heuliez (M) Sdn Bhd, established since 1996, is the oldest entity in our conglomerate. Specialising in strategic land-bank acquisition and property development projects, Heuliez has nearly three decades of experience in Malaysian property development, delivering quality residential and commercial projects across the country.',
      image:
        'https://readdy.ai/api/search-image?query=Modern%20luxury%20real%20estate%20property%20development%20with%20contemporary%20architecture%20showing%20residential%20and%20commercial%20buildings%20with%20landscaped%20gardens%20and%20green%20spaces%20professional%20architectural%20photography%20with%20clear%20blue%20sky%20and%20tropical%20setting%20in%20Malaysia&width=800&height=600&seq=realestate1&orientation=landscape',
      features: [
        {
          icon: 'ri-map-pin-line',
          title: 'Land Acquisition',
          desc: 'Strategic land-bank development in high-growth areas.',
        },
        {
          icon: 'ri-building-line',
          title: 'Property Development',
          desc: 'Commercial and residential development projects with sustainable design.',
        },
        {
          icon: 'ri-home-line',
          title: 'Quality Developments',
          desc: 'Delivering premium residential and commercial properties across Malaysia.',
        },
        {
          icon: 'ri-calendar-line',
          title: 'Since 1996',
          desc: 'Nearly three decades of property development expertise in Malaysia.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Property Development',
    },
    {
      id: 'export-trade',
      label: 'Division 04',
      icon: 'ri-ship-line',
      title: 'B2B Export Trade',
      company: 'Aravion Zeus Sdn Bhd',
      description:
        'Aravion Zeus Sdn Bhd operates as our global B2B export trade hub, connecting Malaysian products to international markets. With established trade routes across five continents, we facilitate seamless cross-border commerce with multi-currency support.',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20business%20laptop%20displaying%20modern%20B2B%20e-commerce%20marketplace%20dashboard%20with%20clean%20interface%20showing%20product%20listings%20pricing%20charts%20and%20inventory%20data%20on%20desk%20in%20bright%20office%20environment%20contemporary%20business%20technology%20photography%20style%20with%20palm%20oil%20trading%20theme&width=800&height=600&seq=marketplace&orientation=landscape',
      features: [
        {
          icon: 'ri-global-line',
          title: 'Global Network',
          desc: 'Trade routes spanning five continents with established partnerships.',
        },
        {
          icon: 'ri-money-dollar-circle-line',
          title: 'Multi-Currency',
          desc: 'Seamless transactions with multi-currency support.',
        },
        {
          icon: 'ri-file-list-line',
          title: 'Trade Compliance',
          desc: 'Full regulatory compliance for international trade.',
        },
        {
          icon: 'ri-bank-line',
          title: 'Trade Financing',
          desc: 'Integrated financing options through banking partners.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Export Trade',
    },
    {
      id: 'advertising',
      label: 'Division 05',
      icon: 'ri-megaphone-line',
      title: 'Advertising & Marketing',
      company: 'Drixem Sdn Bhd (MSC Status 2006)',
      description:
        'Drixem Sdn Bhd, awarded MSC Status in 2006, is our advertising and marketing specialist. We deliver comprehensive brand strategy, creative campaigns, digital marketing, and media planning services for businesses across industries.',
      image:
        'https://readdy.ai/api/search-image?query=Creative%20Malaysian%20advertising%20agency%20workspace%20with%20diverse%20Malay%20team%20brainstorming%20around%20large%20screen%20showing%20marketing%20campaign%20designs%20colorful%20mood%20boards%20brand%20strategy%20materials%20on%20walls%20modern%20open%20plan%20office%20in%20Kuala%20Lumpur%20with%20natural%20lighting%20professional%20creative%20workspace%20photography&width=800&height=600&seq=div-adv-my-v3&orientation=landscape',
      features: [
        {
          icon: 'ri-award-line',
          title: 'MSC Status',
          desc: 'Recognised by MDEC with MSC Status since 2006.',
        },
        {
          icon: 'ri-palette-line',
          title: 'Brand Strategy',
          desc: 'Comprehensive branding and creative campaign management.',
        },
        {
          icon: 'ri-bar-chart-line',
          title: 'Digital Marketing',
          desc: 'Data\u2011driven digital marketing and media planning.',
        },
        {
          icon: 'ri-video-line',
          title: 'Content Creation',
          desc: 'Professional content production and creative services.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Marketing Services',
    },
    {
      id: 'ai-it-tech',
      label: 'Division 06',
      icon: 'ri-robot-line',
      title: 'Physical AI & IT Tech',
      company: 'Nexa Prime Sdn Bhd',
      description:
        'Nexa Prime Sdn Bhd is our Physical AI and IT Tech division — pioneering the integration of artificial intelligence with hardware, logistics, and industrial infrastructure at massive scale. While many companies use AI for software, Nexa Prime has successfully embedded Physical AI into real-world business operations across all Drixem Group divisions. This approach, proven by industry leaders like Nvidia and Amazon, delivers cutting-edge technology solutions including AI-powered automation, Learning Management Systems, and custom software development.',
      image:
        'https://readdy.ai/api/search-image?query=Futuristic%20AI%20powered%20industrial%20automation%20control%20room%20with%20multiple%20screens%20showing%20real%20time%20data%20analytics%20robotic%20arm%20operations%20and%20smart%20factory%20monitoring%20systems%20modern%20technology%20workspace%20with%20holographic%20displays%20and%20neural%20network%20visualizations%20professional%20technology%20photography&width=800&height=600&seq=div-physical-ai-v1&orientation=landscape',
      features: [
        {
          icon: 'ri-robot-line',
          title: 'Physical AI',
          desc: 'Integrating AI with hardware, logistics, and industrial infrastructure — proven by Nvidia and Amazon.',
        },
        {
          icon: 'ri-dashboard-line',
          title: 'AI-Powered Automation',
          desc: 'Intelligent automation solutions transforming operations across all group divisions.',
        },
        {
          icon: 'ri-graduation-cap-line',
          title: 'LMS Platforms',
          desc: 'Advanced learning management systems for corporate training.',
        },
        {
          icon: 'ri-code-box-line',
          title: 'Custom Development',
          desc: 'Tailored software solutions for specific business needs.',
        },
      ],
      linkTo: '/contact',
      linkText: 'Inquire About Physical AI Solutions',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-0 pb-0">
        <div className="relative w-full min-h-[280px] sm:min-h-[320px] md:min-h-[380px]">
          <img
            src="https://readdy.ai/api/search-image?query=Panoramic%20aerial%20view%20of%20Malaysian%20industrial%20landscape%20showing%20modern%20factories%20palm%20oil%20plantations%20and%20commercial%20buildings%20with%20dramatic%20golden%20hour%20lighting%20professional%20wide%20angle%20photography%20showcasing%20diverse%20business%20operations%20and%20industrial%20excellence&width=1920&height=600&seq=div-header-v2&orientation=landscape"
            alt="Our Business Divisions - Drixem Group Malaysia Palm Oil Manufacturing Property Export"
            title="Drixem Group Business Divisions"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="relative z-10 flex items-center justify-center min-h-[280px] sm:min-h-[320px] md:min-h-[380px] pt-24 pb-16 sm:pb-20 px-4 sm:px-6">
            <div className="flex flex-col items-center justify-center text-center w-full max-w-4xl mx-auto">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-3 sm:mb-4 leading-tight text-center w-full">
                Our Business Divisions
              </h1>
              <p className="text-sm sm:text-base md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed text-center w-full px-4 sm:px-2">
                Six strategic pillars driving <strong>innovation</strong>,{' '}
                <strong>sustainable growth</strong>, and{' '}
                <strong>global reach</strong> across diverse industries
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Investor Notice Section - Below Banner */}
      <section className="py-6 bg-gradient-to-r from-primary-50 to-accent-50 border-b border-primary-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
            <div className="flex items-center gap-2 px-5 py-2.5 bg-white rounded-full shadow-sm border border-primary-200">
              <i className="ri-information-line text-primary-600 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm text-gray-700 font-medium text-center leading-snug">New investors &amp; partners are limited to involvement in one division/subsidiary only</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-2.5 bg-white rounded-full shadow-sm border border-accent-200">
              <i className="ri-money-dollar-circle-line text-accent-600 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm text-gray-700 font-medium text-center leading-snug">For non-active partners, quarterly interim profit sharing</span>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-28">
          {divisions.map((div, index) => (
            <div
              key={div.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
            >
              <div
                className={`w-full h-96 ${
                  index % 2 === 1 ? 'lg:order-2' : ''
                }`}
              >
                <img
                  src={div.image}
                  alt={`${div.title} - ${div.company}`}
                  title={`${div.title} Division - Drixem Group`}
                  className="w-full h-full object-cover object-top rounded-2xl shadow-xl"
                />
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${div.icon} text-2xl text-primary-600`}></i>
                  </div>
                  <span className="text-sm font-semibold text-primary-600 uppercase tracking-wide">
                    {div.label}
                  </span>
                </div>

                <h2 className="text-4xl font-display font-bold text-gray-900 mb-2">
                  {div.title}
                </h2>
                <p className="text-lg font-semibold text-primary-600 mb-6">
                  {div.company}
                </p>

                <p className="text-gray-600 mb-8 leading-relaxed">
                  {div.description}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                  {div.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-lg flex-shrink-0">
                        <i
                          className={`${feature.icon} text-xl text-primary-600`}
                        ></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-1">
                          {feature.title}
                        </h3>
                        <p className="text-sm text-gray-600">{feature.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <Link
                  to={div.linkTo}
                  className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  <span>{div.linkText}</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Overseas Investor Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="bg-white border-2 border-primary-200 rounded-2xl p-8 md:p-12 shadow-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-primary-50 rounded-bl-full opacity-60"></div>
            <div className="relative z-10">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-xl">
                  <i className="ri-global-line text-3xl text-primary-600"></i>
                </div>
                <div>
                  <h2 className="text-2xl md:text-3xl font-display font-bold text-gray-900">For Overseas Investors</h2>
                  <p className="text-sm text-primary-600 font-semibold">Seamless Investment Entry Into Malaysia</p>
                </div>
              </div>
              <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                For overseas investors, we can arrange the <strong>Malaysia My Second Home (MM2H)</strong> programme and <strong>MIDA (Malaysian Investment Development Authority)</strong> approvals to ease your investment entry into Malaysia. We also provide suggestions on <strong>international schools</strong> for your children. Our team will guide you through the entire process.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-lg flex-shrink-0">
                    <i className="ri-home-heart-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">MM2H Programme</h3>
                    <p className="text-sm text-gray-600">Long-term residency visa enabling you to live and invest in Malaysia with ease.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-lg flex-shrink-0">
                    <i className="ri-government-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">MIDA Approval</h3>
                    <p className="text-sm text-gray-600">Government-backed investment facilitation with tax incentives and regulatory support.</p>
                  </div>
                </div>
              </div>
              <Link
                to="/investor-relations"
                className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <span>View Full Details on Investor Relations</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DivisionsPage;
